// extracted by mini-css-extract-plugin
export var quillEditor = "_o1-1";
export var variable = "_o1-0";